import { CHINA_LANGUAGES, GLOBAL_LANGUAGES, SITE } from '@/app/constants';
import type { SupportedLanguage } from '@/app/types';

// 全球站支持的语言和默认语言
const GLOBAL_LANGUAGE_CONFIG: {
  supported: SupportedLanguage[];
  default: SupportedLanguage;
} = {
  supported: GLOBAL_LANGUAGES,
  default: 'en',
};

// 中国站支持的语言和默认语言
const CHINA_LANGUAGE_CONFIG: {
  supported: SupportedLanguage[];
  default: SupportedLanguage;
} = {
  supported: CHINA_LANGUAGES,
  default: 'zh',
};

export const LANGUAGE_CONFIG = SITE === 'china' ? CHINA_LANGUAGE_CONFIG : GLOBAL_LANGUAGE_CONFIG;
